export default "__VITE_ASSET__DoMI_yhN__"